import {
  IWorkflowTemplate,
  TWorkflowTemplateCategory,
  WORKFLOW_TEMPLATE_CATEGORIES,
} from '@commenda/types';

/** Readers for the metadata fields the backend rides on list serializations beside the typed
 * fields; malformed values read as empty. */
export class WorkflowTemplateMetadataHelper {
  static readonly CATEGORY_LABELS: Record<TWorkflowTemplateCategory, string> = {
    TP_POLICY: 'Policy',
    TP_BENCHMARK: 'Benchmark',
    TP_LOCAL_FILE: 'Local file',
    TP_MASTER_FILE: 'Master file',
    TP_CBCR: 'CbCR',
  };

  static getTags(template: IWorkflowTemplate): string[] {
    return Array.isArray(template.tags)
      ? template.tags.filter((tag): tag is string => typeof tag === 'string')
      : [];
  }

  static getCategory(
    template: IWorkflowTemplate
  ): TWorkflowTemplateCategory | null {
    return (
      WORKFLOW_TEMPLATE_CATEGORIES.find(
        (candidate) => candidate === template.category
      ) ?? null
    );
  }
}
